import React, { memo } from 'react';
import SortingMenuMobile from './sortingMenuMobile/SortingMenuMobile';
import SortingMenuDesktop from './sortingMenuDesktop/SortingMenuDesktop';
import useDevice from '@/hooks/useDevice';
import styles from './SortingMenu.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import { useRouter } from 'next/router';
const SortingMenu = () => {
  const {
    isMobile
  } = useDevice();
  const router = useRouter();
  const pageContentSet = {
    '/all-boomgardi': {
      boomgardi: 1
    },
    '/all-cottage': {
      cottage: 1
    }
  };
  const pageQuery = pageContentSet[router.pathname] || {};
  const handleChangeSort = (index: number) => {
    router.push({
      pathname: '/search',
      query: {
        ...pageQuery,
        ...router.query,
        sortBy: index
      }
    });
  };
  return <>
      {isMobile ? <SortingMenuMobile handleSort={handleChangeSort} /> : <Box className={styles['sorting-menu-container']}>
          <Box className={styles['sorting-title-section']}>
            <Icon name="arrow-3" type="highEmphasis" />
            <Typography variant="bodyM">مرتب سازی:</Typography>
          </Box>
          <SortingMenuDesktop handleSort={handleChangeSort} />
        </Box>}
    </>;
};
export default memo(SortingMenu);